/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { ApplicationSummariesControllerUpdateMutationRequest, ApplicationSummariesControllerUpdateMutationResponse, ApplicationSummariesControllerUpdatePathParams, ApplicationSummariesControllerUpdate400, ApplicationSummariesControllerUpdate401, ApplicationSummariesControllerUpdate403, ApplicationSummariesControllerUpdate404 } from "../../models/checklistsController/ApplicationSummariesControllerUpdate";

function getApplicationSummariesControllerUpdateUrl(id: ApplicationSummariesControllerUpdatePathParams["id"]) {
  const res = { method: 'PATCH', url: `/api/v1/checklist-application-summaries/${id}` as const }  
  return res
}

/**
 * @summary Update a checklist application summary
 * {@link /api/v1/checklist-application-summaries/:id}
 */
export async function applicationSummariesControllerUpdate(id: ApplicationSummariesControllerUpdatePathParams["id"], data?: ApplicationSummariesControllerUpdateMutationRequest, config: Partial<RequestConfig<ApplicationSummariesControllerUpdateMutationRequest>> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const requestData = data  
  
  const res = await request<ApplicationSummariesControllerUpdateMutationResponse, ResponseErrorConfig<ApplicationSummariesControllerUpdate400 | ApplicationSummariesControllerUpdate401 | ApplicationSummariesControllerUpdate403 | ApplicationSummariesControllerUpdate404>, ApplicationSummariesControllerUpdateMutationRequest>({ method : "PATCH", url : getApplicationSummariesControllerUpdateUrl(id).url.toString(), data : requestData, ... requestConfig, headers : { 'Content-Type': 'application/vnd.api+json', ...requestConfig.headers } })  
  return res.data
}